/**
 * @generated SignedSource<<b8befb8b949aafc1c4564d68ee6e4af7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ErrorReportItem_errorReport$data = {
  readonly created: any;
  readonly id: string;
  readonly reason: string;
  readonly " $fragmentType": "ErrorReportItem_errorReport";
};
export type ErrorReportItem_errorReport$key = {
  readonly " $data"?: ErrorReportItem_errorReport$data;
  readonly " $fragmentSpreads": FragmentRefs<"ErrorReportItem_errorReport">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ErrorReportItem_errorReport",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    }
  ],
  "type": "ErrorReport",
  "abstractKey": null
};

(node as any).hash = "58d736b8981ffc683a87391eaaf33cbf";

export default node;
